export default [
	{
		name: 'root',
		label: 'Wrapper',
		selector: '&'
	},

	{
		name: 'featuredImageTitle',
		label: 'Featured Title',
		selector: '& .inspi-featured .inspi-featured-text'
	},

	{
		name: 'featuredImage',
		label: 'Featured Image',
		selector: '& .inspi-featured .inspi-featured-img'
	},

	{
		name: 'gridItem',
		label: 'Grid Item',
		selector: '& .inspi-grid-item'
	},

	{
		name: 'gridImage',
		label: 'Grid Image',
		selector: '& .inspi-grid-image'
	},

	{
		name: 'gridItemContent',
		label: 'Grid Item Content',
		selector: '& .inspi-grid-content'
	},

	{
		name: 'gridTitle',
		label: 'Grid Title',
		selector: '& .inspi-grid-title'
	},

	{
		name: 'gridDescription',
		label: 'Grid Description',
		selector: '& .inspi-grid-description'
	},

	{
		name: 'gridLabel',
		label: 'Grid Price Label',
		selector: '& .inspi-grid-pricing-label'
	},
 
	{
		name: 'gridPricing',
		label: 'Grid Price From',
		selector: '& .inspi-grid-pricing-from'
	}
]